import React, { ForwardedRef, forwardRef, HTMLProps } from 'react';

import { onInputPast } from './helpers';
import { InputType } from './inputType';

interface IInputProps extends Omit<HTMLProps<HTMLInputElement>, 'as' | 'type'> {
  type: InputType;
  disablePasting?: boolean;
}

const Input = forwardRef(
  ({ disablePasting, onPaste, ...rest }: IInputProps, ref: ForwardedRef<HTMLInputElement>) => (
    <input {...rest} onPaste={event => onInputPast(event, onPaste, disablePasting)} ref={ref} />
  ),
);

Input.displayName = 'Input';

export { Input };
